module.exports = __webpack_public_path__ + "static/media/arrow_next_blue.3d83aa72.svg";